import React, { Fragment } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postDnataForm } from "../../redux/actions/dnataActions";

const DeclarationForm = ({ appData, postDnataFormFunc }) => {
  let initialData = {};
  if (appData.dnataOnboarding && appData.dnataOnboarding.declaration) {
    initialData = {
      ...initialData,
      ...appData.dnataOnboarding.declaration,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const initialState = {
    box21: {
      htmlObj: <HorizontalLine text={"Section 11 - Declaration"} />,
    },
    box22: {
      htmlObj: (
        <Fragment>
          <p>
            1. I agree that in the event of a successful offer of employment,
            Dnata catering UK in conjunction with the Civil Aviation Authority
            are required to undertake a Basic Criminal Record Check.
          </p>
          <p>
            2. I understand that Dnata catering UK require a comprehensive and
            detailed account of my 5 year referencing history within the
            previous 5 years in accordance with the Civil Aviation Authority
            regulations. I understand that the collection and processing of
            personal data which has been provided is a company requirement for
            security and recruitment purposes in order to progress my
            application or offer of employment.
          </p>
          <p>
            {`3. I confirm that I authorise and consent for Dnata catering UK to
            submit my personal data for processing in order to verify
            information to include my full name, my date of birth, my address
            and my national insurance number. I understand that Dnata catering
            UK will share this data with third parties such as former employers,
            educational establishments, government agencies and all other
            referee's listed within this application form for the purpose of
            veryfing dates of employment and / or those that require
            confirmation, compulsory vetting and additional basic security
            questions.`}
          </p>
          <p>
            4. I declare that the information given in this application is
            complete and accurate and understand that providing inaccurate,
            misleading or incomplete information may be a ground for refusal of
            employment or disciplinary proceedings or, in appropriate cases, may
            result in criminal proceedings.
          </p>
          <p>
            5. I understand that should I be successful in my application, any
            misrepresentation of the facts contained within this form which are
            subsequently indentified may be deemed to be an act of gross
            misconduct and may result in dismissal from the Company or, in
            appropriate cases, may result in criminal proceedings.
          </p>
          <br />
          <p>
            <bold>
              After submitting your application, you will need to download and
              print this Declaration page. You will then need to sign the
              declaration and upload a picture of the signed page. <br />
              By signing this declaration you indicate your understanding,
              agreement and consent of the above declaration. Failure to sign
              the below will indicate a non consent; in this event your
              application or offer of employment will not be progressed and may
              be withdrawn.
            </bold>
          </p>
        </Fragment>
      ),
    },
    declaration: {
      title:
        "I understand this declaration and will download this page to sign to show my agreement.",
      value: getVal("declaration"),
      type: "singlecheckbox",
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postDnataFormFunc("declaration", {
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/dnata-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Declaration"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/dnata-onboarding")}
      onboardingBranch={"dnata"}
    />
  );
};
DeclarationForm.propTypes = {
  appData: any,
  postDnataFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDnataFormFunc: postDnataForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DeclarationForm);
